module.exports = __webpack_public_path__ + "img/linkaja.7cb66352.png";